/**
 * ⚠️ WARNING ⚠️
 *
 * This directory is Proof of Concept code for Snowplow tracking implementation.
 * The implementation should be moved fe-toolkit after POC completes.
 */
import events from './events'

export { initSnowplowTracker } from './initSnowplowTracker'

export { trackConsent } from './trackConsent'

export const snowplowEvents = events
